module.exports = __webpack_public_path__ + "img/notice1.5a4fc5eb.png";